import { defineStore, skipHydrate } from 'pinia'
import { INTERNAL_LANGUAGES, COUNTRIES_LIST, OTHER_COUNTRY_ID } from '@/utils/constants/locale'
import { COOKIE_OPTIONS } from '@/utils/constants/cookies'

const DEFAULT_LANGUAGE = 'lv'
const DEFAULT_COUNTRY = 'LV'

export const useLocaleStore = defineStore('localeStore', () => {
  const selectedLanguage = ref<string>('')
  const selectedCountry = ref<string>('')

  let languageCookie: Ref<string>
  let countryCookie: Ref<string>

  const selectedCountrySameAsCookie = computed(() => selectedCountry.value === countryCookie.value)

  function initCookies() {
    languageCookie = useCookie<string>('language', { ...COOKIE_OPTIONS, default: () => DEFAULT_LANGUAGE })
    countryCookie = useCookie<string>('country', { ...COOKIE_OPTIONS, default: () => DEFAULT_COUNTRY })

    selectedLanguage.value = languageCookie.value
    selectedCountry.value = countryCookie.value
  }

  function setSelectedLanguage(value: string) {
    if (!INTERNAL_LANGUAGES.includes(value) || value === selectedLanguage.value) return

    selectedLanguage.value = value
    languageCookie.value = value
  }

  function setSelectedCountry(value: string) {
    if (!COUNTRIES_LIST.includes(value)) {
      value = OTHER_COUNTRY_ID
    }

    selectedCountry.value = value
    countryCookie.value = value
  }

  function resetSelectedLanguageCountry() {
    selectedLanguage.value = languageCookie.value
    selectedCountry.value = countryCookie.value
  }

  return {
    selectedCountry: skipHydrate(selectedCountry),
    selectedLanguage,
    selectedCountrySameAsCookie,
    initCookies,
    setSelectedLanguage,
    setSelectedCountry,
    resetSelectedLanguageCountry
  }
})
